import {
  doesTeamAlreadyExistAsync,
  getAdUserDetailsAsync,
  isAgentActive,
  isCodePrefixFormatCorrect,
} from '../../../../../Helpers/AgentHelper';
import { formatMessage } from '../../../../../Localization/formatMessage';
import Messages from '../../../../../Localization/Messages';

export const count = 1;

export const mapAgentsToCostCenters = agents => {
  const costCenters = [];
  agents.forEach(agent => {
    if (isAgentActive(agent) && !arrayIncludesCostCenter(costCenters, agent.costCenter)) {
      costCenters.push({
        checked: true,
        displayName: `${agent.costCenter.name} (${agent.costCenter.code})`,
        externalSalesCode: null,
        id: agent.costCenter.id,
      });
    }
  });
  return costCenters;
};

export const checkAllCostCenters = (formData, setFormData) => {
  const costCenters = formData.costCenters.map(cc => {
    return { ...cc, checked: !formData.allCostCentersChecked };
  });
  setFormData({
    ...formData,
    allCostCentersChecked: !formData.allCostCentersChecked,
    costCenters: costCenters,
  });
};

export const updateDataInRow = (costCenterId, propertyName, newValue, formData, setFormData) => {
  const costCenters = [];
  formData.costCenters.forEach(cc => {
    if (cc.id === costCenterId) {
      costCenters.push({ ...cc, [propertyName]: newValue });
    } else {
      costCenters.push(cc);
    }
  });

  const allCostCentersChecked = costCenters.filter(cc => cc.checked).length === costCenters.length;

  setFormData({
    ...formData,
    costCenters: costCenters,
    allCostCentersChecked: allCostCentersChecked,
  });
};

export const validateCodePrefixInput = async codePrefix => {
  if (codePrefix?.trim()) {
    if (!isCodePrefixFormatCorrect(codePrefix)) {
      return {
        error: formatMessage(Messages.common_codePrefixIncorrect),
      };
    } else {
      const doesTeamExist = await doesTeamAlreadyExistAsync(codePrefix);
      if (doesTeamExist) {
        return { error: formatMessage(Messages.error_CodePrefixExists) };
      } else {
        const adUser = await getAdUserDetailsAsync(codePrefix);
        if (adUser) {
          return {
            error: null,
            nameFromAd: adUser.displayName,
          };
        }
        return { error: null };
      }
    }
  } else {
    return { error: '' };
  }
};

export const validateFieldInputs = formData => {
  const errors = { name: null, costCenters: null };

  if (!formData.name?.trim()) {
    errors.name = '';
  }

  if (!isAtLeastOneCostCenterChecked(formData.costCenters)) {
    errors.costCenters = formatMessage(Messages.copyCostCenters_costCenterNotSelected);
  }

  return errors;
};

export const generateCreateRequest = formData => {
  return {
    commonAgentName: formData.name,
    agents: formData.costCenters
      .filter(cc => cc.checked)
      .map(cc => {
        return {
          costCenterId: cc.id,
          externalSalesCode: cc.externalSalesCode?.length === 0 ? null : cc.externalSalesCode,
        };
      }),
  };
};

export const canFormBeSubmitted = errors => {
  for (const key of Object.keys(errors)) {
    if (errors[key] !== null) {
      return false;
    }
  }
  return true;
};

const isAtLeastOneCostCenterChecked = costCenters => {
  return costCenters?.some(cc => cc.checked);
};

const arrayIncludesCostCenter = (array, costCenter) => {
  return array.some(item => item.id === costCenter.id);
};
